import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { closeWindow } from '../shared/utils/utils';

@Component({
  selector: 'app-used-link',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './used-link.component.html',
  styleUrl: './used-link.component.css'
})
export class UsedLinkComponent {
  options: AnimationOptions = {
    path: 'assets/animations/success.json',
    loop: 0
  }

  close() {closeWindow()}
}
